export class Contact {
    public _id:String;
    public name: String;
    public mail : String ; 
    public description:String;
    public subject:String;
    public phone:String;
    constructor(){}
  }
  